import z from 'zod';
import {epochTimestamp} from '../_other';
import {tradeMessageDbSchema} from './tradeMessageDbSchema';
import {tradeWriteSchema} from './tradeWriteSchema';

/** DB row: same field semantics as {@link tradeWriteSchema} (`exitPrice`/`closedAt`/`profitLoss` use `0` as unset / open). */
export const tradeDbSchema = tradeWriteSchema.omit({messages: true}).extend({
  createdAt: epochTimestamp,
  updatedAt: epochTimestamp,

  /** message and appended to the messages array in db */
  messages: z.array(tradeMessageDbSchema).default([]),
});

export interface TradeDb extends z.infer<typeof tradeDbSchema> {}
